import http from './http';
import { handleResponse } from '@/shared/utils/promise-helpers';

export const getCampaignVoiceList = (agentId) =>
  http
    .get('/campaign-dialer', { params: { username: agentId } })
    .then(handleResponse);
